import { render } from "./Clases.vue?vue&type=template&id=d5b9229c&scoped=true"
import script from "./Clases.vue?vue&type=script&lang=js"
export * from "./Clases.vue?vue&type=script&lang=js"

import "./Clases.vue?vue&type=style&index=0&id=d5b9229c&scoped=true&lang=css"

import exportComponent from "C:\\ProductFactory\\analiaperez-landing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b9229c"]])

export default __exports__